import enMessages from '../dictionaries/en.json';
import esMessages from '../dictionaries/es.json';
// We enumerate all dictionaries here for better linting and typescript support
// We also get the default import for cleaner types
export const dictionaries = {
  en: enMessages,
  es: esMessages
};
